import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Autocomplete, Paper, TextField } from "@mui/material";
import Button from "../../components/Button";

import "./index.scss";
import { getAvailableCourses, addGroupCourse } from "../../api/coursesGroups";

const GroupAircraftAdd = ({ history }) => {
  const { t } = useTranslation();
  const [groupName, setGroupName] = useState("");

  const [courses, setCourses] = useState([]);
  const [selectedCourses, setSelectedCourses] = useState([]);

  const [groupNameErrorText, setGroupNameErrorText] = useState(null);

  useEffect(() => {
    (async () => {
      const newCourses = await getAvailableCourses();
      setCourses(newCourses);
    })();
  }, []);

  function handleGroupName(value) {
    setGroupName(value);
    if (!value) return setGroupNameErrorText(t("course_groups.group_name_required"));
    setGroupNameErrorText(null);
  }

  async function addCourseGroup() {
    if (!groupName) return handleGroupName(groupName);
    const result = await addGroupCourse(groupName, selectedCourses);
    if (result.ok) {
      history.push("/courses_groups");
    }
  }

  return (
    <>
      <h2>{t("course_groups.add_title")}</h2>

      <Paper variant="outlined" className="add-courses-group" style={{ padding: "1rem 1.5rem" }}>
        <TextField
          className="add-field"
          variant="outlined"
          size="small"
          label={t("course_groups.group_name_required_label")}
          value={groupName}
          onChange={(event) => handleGroupName(event.target.value)}
          error={!!groupNameErrorText}
          helperText={groupNameErrorText}
        />
        <Autocomplete
          className="select-course"
          size="small"
          multiple
          options={courses}
          getOptionLabel={(course) => course.name}
          filterSelectedOptions
          onChange={(event, newCourses) => setSelectedCourses(newCourses)}
          renderInput={(params) => <TextField {...params} variant="outlined" label={t("course_groups.select_courses")} />}
        />
        <Button title={t("course_groups.add_action")} onClick={addCourseGroup}>
          {t("course_groups.add_course_group")}
        </Button>
        <Button title={t("navigate_back")} onClick={() => history.goBack()}>
          {t("cancel")}
        </Button>
      </Paper>
    </>
  );
};

export default GroupAircraftAdd;
